/**
 *
 * Sorter
 *
 */

import React from "react"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';
import { isEqual } from "lodash"
import { CaretUpOutlined, CaretDownOutlined } from "@ant-design/icons"
import "./index.less"
/* eslint-disable react/prefer-stateless-function */
class Sorter extends React.Component {
  state = {
    sortList: {
      active: false,
      key: "-",
      type: "asc",
    },
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.data, this.props.data)) {
      this.setState({
        sortList: {
          active: false,
          key: "-",
          type: "asc",
        },
      })
    }
  }

  sortList = (list, key, keyObject, type) => {
    const { sortList } = this.state
    sortList.type = type
    sortList.active = true
    sortList.key = key
    list = sorterBy(list, keyObject, type)
    this.setState({ sortList }, () => {
      this.props.onChange(list)
    })
  }

  render() {
    const { sortList } = this.state
    const { data, byKey } = this.props
    return (
      <div
        className="Sorter-component"
        onClick={() =>
          this.sortList(
            Array.isArray(data) ? data : [],
            "divisions",
            byKey,
            sortList.type == "asc" ? "desc" : "asc"
          )
        }>
        <CaretUpOutlined
          className={`Sorter-component-up ${
            sortList.key === "divisions" &&
            sortList.active &&
            sortList.type === "asc"
              ? "Sorter-component-active"
              : ""
          }`}
        />
        <CaretDownOutlined
          className={`Sorter-component-down ${
            sortList.key === "divisions" &&
            sortList.active &&
            sortList.type === "desc"
              ? "Sorter-component-active"
              : ""
          }`}
        />
      </div>
    )
  }
}
Sorter.defaultProps = {
  data: [],
  key: "name",
  onChange: () => {},
}
Sorter.propTypes = {}

export default Sorter
